<template>
  <v-card class="mb-3">
    <v-card-text class="pb-2">
      <v-row>
        <div class="d-flex flex-grow-1 px-3">
          <div>
                <span class="title text--primary font-weight-regular">
                  {{ produto.cotacaoConjuntaProduto.id }} -
                  {{ produto.cotacaoConjuntaProduto.produto.descricao | truncate(60) }}&nbsp;
                  ({{ produto.cotacaoConjuntaProduto.quantidade }}
                  {{ produto.cotacaoConjuntaProduto.unidadeMedida.descricao }})
                </span>
            <div v-if="isRespondivel">
              <span class="body-2 grey--text text--darken-1">
            {{ produto.cotacaoConjuntaProduto.especificacaoProduto | truncate(50) | naoInformado }}
                <px-detalhes-produto
                  small
                  :produto="produto.cotacaoConjuntaProduto"/>
              </span>
            </div>
          </div>
        </div>
        <div class="d-flex mr-3" v-if="!isRespondida">
          <px-situacao-resposta-produto-chip
            close
            :situacao="produto.situacao"
            @close="onCloseSituacao(produto)"/>
        </div>
        <div class="d-flex mr-3" v-if="isRespondivel">
          <px-recusar-produto @change="onChangeSituacao"/>
        </div>
        <div class="d-flex mr-3" v-if="isRespondivel">
          <px-anexo badge-color="secondary"
                    v-model="produto.arquivos"
                    :max="3"
                    top
                    :bottom="false"
                    upload-base-path="fornecedor/files"
                    @loading="onFileLoad">
            <template v-slot:activator="{ on }">
              <v-btn small color="primary" v-on="on">
                Adicionar anexo
              </v-btn>
            </template>
          </px-anexo>
        </div>
      </v-row>
    </v-card-text>
    <div class="px-4" v-if="isRespondivel">
      <v-row dense>
        <v-col cols="12" sm="4"
               class="text-center"
               v-for="(prazo, idx) in produto.prazos"
               :key="idx">
          <px-cotacao-conjunta-resposta-item-prazo
            ref="prazoItem"
            :produto="produto"
            :prazo="prazo"/>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="4" md="3">
          <px-select-enum
            dense
            label="Aplicação ICMS"
            class="required"
            :error="$v.produto.impostos.tipoAplicacaoIcms.$error"
            @blur="$v.produto.impostos.tipoAplicacaoIcms.$touch()"
            @change="onChangeAplicacaoIcms"
            v-model="produto.impostos.tipoAplicacaoIcms"
            :items="aplicacoesImpostoIcms"/>
        </v-col>
        <v-col cols="12" sm="4" md="3">
          <px-input-percentage
            dense
            label="ICMS"
            class="required"
            ref="icms"
            :disabled="isIcmsIsento"
            :error="$v.produto.impostos.icms.$error"
            @blur="$v.produto.impostos.icms.$touch()"
            v-model="produto.impostos.icms"/>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <px-select-enum
            dense
            label="Aplicação IPI"
            class="required"
            :error="$v.produto.impostos.tipoAplicacaoIpi.$error"
            @blur="$v.produto.impostos.tipoAplicacaoIpi.$touch()"
            @change="onChangeAplicacaoIpi"
            v-model="produto.impostos.tipoAplicacaoIpi"
            :items="aplicacoesImposto"/>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <px-input-percentage
            dense
            label="IPI"
            class="required"
            ref="ipi"
            :disabled="isIpiIsento"
            :error="$v.produto.impostos.ipi.$error"
            @blur="$v.produto.impostos.ipi.$touch()"
            v-model="produto.impostos.ipi"/>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-textarea
            outlined
            auto-grow
            class="required"
            label="Especificação"
            counter="1500"
            rows="1"
            :error="$v.produto.especificacaoProduto.$error"
            @blur="$v.produto.especificacaoProduto.$touch()"
            v-model="produto.especificacaoProduto"
          />
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<script>
import { AplicacaoImposto, AplicacaoImpostoIpi, SituacaoRespostaCotacaoProduto } from 'px-business-components';
import { required } from 'vuelidate/lib/validators';
import validationMixin from '@/mixins/validation-mixin';
import CotacaoConjuntaRespostaItemPrazo from './CotacaoConjuntaRespostaItemPrazo.vue';

export default {
  mixins: [validationMixin],
  props: {
    produto: Object,
  },
  data() {
    return {
      refs_children: [],
      aplicacoesImposto: AplicacaoImpostoIpi.values,
      aplicacoesImpostoIcms: AplicacaoImposto.values
        .filter((item) => item.key !== AplicacaoImposto.keys.CALCULAR.key),
      hasFileLoading: false,
    };
  },
  computed: {
    isRespondivel() {
      return this.isRespondida;
    },
    isRespondida() {
      return this.produto.situacao
        === SituacaoRespostaCotacaoProduto.keys.RESPONDIDA.key;
    },
    labelPreco() {
      return `Preço por ${this.produto.cotacaoConjuntaProduto.unidadeMedida.descricao}`;
    },
    isIcmsIsento() {
      return this.produto.impostos.tipoAplicacaoIcms
        === AplicacaoImposto.keys.ISENTO.key;
    },
    isIpiIsento() {
      return this.produto.impostos.tipoAplicacaoIpi
        === AplicacaoImposto.keys.ISENTO.key;
    },
  },
  methods: {
    onChangeSituacao(situacao) {
      this.produto.situacao = situacao.key;
    },
    onCloseSituacao() {
      this.produto.situacao = SituacaoRespostaCotacaoProduto.keys.RESPONDIDA.key;
    },
    onFileLoad(loading) {
      this.hasFileLoading = loading;
    },
    onChangeAplicacaoIcms() {
      if (this.isIcmsIsento) {
        this.$refs.icms.$el.getElementsByTagName('input')[0].value = 0;
        this.produto.impostos.icms = 0;
      }
    },
    onChangeAplicacaoIpi() {
      if (this.isIpiIsento) {
        this.$refs.ipi.$el.getElementsByTagName('input')[0].value = 0;
        this.produto.impostos.ipi = 0;
      }
    },
    isInvalid() {
      const isFormInvalid = this.validateForm();
      const forms = (this.$refs.prazoItem || []).map((c) => c.validateForm());
      return isFormInvalid || forms.find((form) => form);
    },
  },
  mounted() {
    this.refs_children = this.$refs.prazoItem;
  },
  validations() {
    if (!this.isRespondivel) {
      return {};
    }
    return {
      produto: {
        especificacaoProduto: {
          required,
        },
        impostos: {
          tipoAplicacaoIcms: {
            required,
          },
          icms: {
            required,
            minValue: (value) => value >= 0,
          },
          ipi: {
            required,
            minValue: (value) => value >= 0,
          },
          tipoAplicacaoIpi: {
            required,
          },
        },
      },
    };
  },
  components: {
    pxCotacaoConjuntaRespostaItemPrazo: CotacaoConjuntaRespostaItemPrazo,
  },
};
</script>
